(function(){
var b=document.getElementById('cs26Burger'),m=document.getElementById('cs26Menu');
if(b&&m){b.addEventListener('click',function(){var o=m.classList.toggle('on');b.setAttribute('aria-expanded',o?'true':'false');});}
var main=document.getElementById('cs26Main'),thumbs=document.getElementById('cs26Thumbs');
if(thumbs&&main){thumbs.addEventListener('click',function(e){var t=e.target.closest('button[data-src]');if(!t)return;Array.prototype.forEach.call(this.querySelectorAll('button'),function(x){x.setAttribute('aria-pressed','false');});t.setAttribute('aria-pressed','true');main.src=t.dataset.src;});}
var choose=document.getElementById('cs26Choose');
if(choose){
var price=document.getElementById('cs26Price'),note=document.getElementById('cs26Note'),sprice=document.getElementById('cs26SPrice'),vid=document.getElementById('cs26Variant'),add=document.getElementById('cs26Add'),sadd=document.getElementById('cs26SAdd');
choose.addEventListener('click',function(e){var t=e.target.closest('button[data-id]');if(!t)return;
Array.prototype.forEach.call(this.querySelectorAll('button'),function(x){x.setAttribute('aria-pressed','false');});
t.setAttribute('aria-pressed','true');vid.value=t.dataset.id;
price.textContent=t.dataset.price;if(sprice)sprice.textContent=t.dataset.price;
note.innerHTML=t.dataset.note+'<br><span class="fs">Free shipping.</span>';
var ok=t.dataset.avail==='true';
[add,sadd].forEach(function(btn){if(!btn)return;btn.disabled=!ok;btn.textContent=ok?'Add to cart':(btn.id==='cs26SAdd'?'Notify me':'Notify when back in stock');});});
}
document.addEventListener('click',function(e){
var t=e.target.closest('[data-notify-open]');if(!t)return;
var row=t.parentNode.querySelector('.nrow');if(!row)return;
t.style.display='none';row.style.display='flex';
var i=row.querySelector('input');if(i)i.focus();
});
document.addEventListener('click',function(e){
var a=e.target.closest('[data-yt]');if(!a)return;
e.preventDefault();
var w=document.createElement('div');w.className='ytbox';
var f=document.createElement('iframe');
f.src='https://www.youtube.com/embed/'+a.getAttribute('data-yt')+'?autoplay=1&rel=0&playsinline=1';
f.title=a.getAttribute('data-yttitle')||'Cox Sauce recipe';
f.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
f.setAttribute('allowfullscreen','');
f.setAttribute('loading','lazy');
w.appendChild(f);a.parentNode.replaceChild(w,a);
});
})();
